<div class="progress-container  popup-container">
  <mat-card style="border-radius: 15px;">
    <div class="sync-dialog">
      <img alt="music-work-logo" src="/assets/login_logo.svg">
      <span>Sync in progress</span>
      <div *ngIf="!current" class="sync-message-container">
        <mat-progress-spinner class="progress" mode="indeterminate"></mat-progress-spinner>
        <span>Loading Sync status</span>
        <span *ngIf="message">{{message}}</span>
      </div>
      <div *ngIf="current" class="sync-bar">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        <span>{{current}} / {{total}} downloaded files</span>
      </div>
    </div>
  </mat-card>
</div>
